<div class="p-modal-head06">
  <h1 id="modalTitle" class="p-modal-head06__title" [innerHTML]="'label.inputCustomerInformation' | staticMsg"></h1>
  <button id="passenger-info-header-btn" class="p-modal-head06__close js-modal-close" (click)="onClickCloseModal()">
    <span class="u-visually-hidden" [innerHTML]="'label.inputCustomerInformation' | staticMsg"></span>
  </button>
</div>
